/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the SalesApiConfiguration configuration object with a given root URL.
 */
export function provideSalesApiConfiguration(rootUrl: string) {
  var config = new SalesApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: SalesApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class SalesApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `O2SalesApiModule.forRoot()`
 */
export interface SalesApiConfigurationParams {
  rootUrl?: string;
}
